import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  container: {
    height: "120px",
    padding: "3%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      flexWrap: "wrap",
      padding: "5px",
    },
  },
  statWrapper: {
    [theme.breakpoints.down("sm")]: {
      width: "50%",
    },
  },
  titleText: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      marginTop: "5px",
    },
  },
  numberText: {
    fontSize: "46px",
    marginTop: "15px",
    color: theme.palette.error.main,
    [theme.breakpoints.down("sm")]: {
      fontSize: "32px",
      marginTop: "5px",
      marginBottom: "5px",
    },
  },
}))

export default styles
